import { Component, OnDestroy, OnInit } from '@angular/core';
import { SettingsService } from '../../settings.service';
import { SettingsBreadCrumbService, BreadCrumbOptions } from '../../settings-breadcrumb.service';
import { Subscription } from 'rxjs';
import { PKIUrls } from 'src/app/constants/pkiurls.constants';
import { IdentityOrganisationApiClient } from 'src/app/services/api-clients/identity-organisation.api-client';
import { IdsForSettingsService } from '../../ids-for-settings.service';
import { PermissionsEnum } from 'src/app/constants/settings.enum';

@Component({
  templateUrl: './identity.page.html'
})
export class IdentityPage implements OnDestroy {

  
  // needed to setup Directives of Permission
  permissionEnum = PermissionsEnum;

  public IdentificationProviderUrl: string = PKIUrls.IdentificationProviderUrl;
  identificationmethods:any;
  disableIdentificationMethod: boolean = false;
  idin: any;
  organisationIdSubscription: Subscription;
  selectedOrganisationId: string = "";
  organisation!: any;
  viduaAuthentication: any;
  viduaIdentification: any;
    
  constructor(private settingsService: SettingsService, 
    private settingsBreadCrumbService: SettingsBreadCrumbService, private idsForSettingsService: IdsForSettingsService, private identityOrganisationApiClient: IdentityOrganisationApiClient) {
    this.organisationIdSubscription = this.idsForSettingsService.selectedOrganisationId$.subscribe(organisationId => {
      if (organisationId === this.selectedOrganisationId) return;
      this.selectedOrganisationId = organisationId;
      // setup specialised breadcrumb
      this.settingsBreadCrumbService.SetOrganisationBasedCrumbs(BreadCrumbOptions.Security(this.selectedOrganisationId), BreadCrumbOptions.Security_Identity(this.selectedOrganisationId));

      this.getIdentitySettings();
    });
  }

  ngOnDestroy(): void {
    if (this.organisationIdSubscription) {
      this.organisationIdSubscription.unsubscribe();
    }
  }

  async getIdentitySettings() {
    (await this.settingsService.getIdentificationmethod(this.selectedOrganisationId)).subscribe({
      next: (identifyMethod: any) => {
        if (identifyMethod.identificationMethod != "sms") {
          this.identificationmethods = "SMSorWhatsApp";
        } else {
          this.identificationmethods = "sms";
        }
        this.disableIdentificationMethod = this.identificationmethods.changeIdentificationMethod;
      },
    });
    (await this.settingsService.getIdin(this.selectedOrganisationId)).subscribe({
      next: (idinData: any) => {
        this.idin = idinData
      }
    });
    (await this.settingsService.getViduaAuthentication(this.selectedOrganisationId)).subscribe({
      next: (viduaAuthData: any) => {
        this.viduaAuthentication = viduaAuthData
      }
    });
    (await this.settingsService.getViduaIdentification(this.selectedOrganisationId)).subscribe({
      next: (viduaIdData: any) => {
        this.viduaIdentification = viduaIdData
      }
    });
  }
  
  updateIdin(event:any){
    this.idin.useIdin = (event.target as HTMLInputElement).checked;
    this.settingsService.updateGeneralSettings({key:"idin", body: this.idin.useIdin}, this.selectedOrganisationId)
  }

  updateIdentificationmethods(event:any){
    this.identificationmethods = (event.target as HTMLInputElement).checked ? "SMSorWhatsApp" : "sms";
    if(this.identificationmethods != "sms") this.settingsService.updateGeneralSettings({key:"identificationMethod", body: ""}, this.selectedOrganisationId)
    else this.settingsService.updateGeneralSettings({key:"identificationMethod", body: this.identificationmethods}, this.selectedOrganisationId)
  }
  
  updateviduaAuthentication(event:any){
    this.viduaAuthentication = (event.target as HTMLInputElement).checked;
    this.settingsService.updateGeneralSettings({key:"viduaAuthentication", body: this.viduaAuthentication}, this.selectedOrganisationId)
  }

  updateViduaIdentification(event:any){
    this.viduaIdentification = (event.target as HTMLInputElement).checked;
    this.settingsService.updateGeneralSettings({key:"ViduaIdentification", body: this.viduaIdentification}, this.selectedOrganisationId)
  }
}
